export enum MacBotActionKind {
  ShowElseForm = 'SHOW_ELSE_FORM',
  ShowResponseForm = 'SHOW_RESPONSE_FORM',
  ShowUserInputForm = 'SHOW_USER_INPUT_FORM',
  ShowGotoForm = 'SHOW_GOTO_FORM',
  ShowButtonForm = 'SHOW_BUTTON_FORM',
  ShowLINKForm = 'SHOW_LINK_FORM',
  ShowHTTPRequestForm = 'SHOW_HTTP_REQUEST_FORM',
  ShowMakeWebHookForm = 'SHOW_MAKE_WEBHOOK_FORM',
  ShowVariableForm = 'SHOW_VARIABLE_FORM',
  ShowConditionForm = 'SHOW_CONDITION_FORM',
  ShowOverrideVariableForm = 'SHOW_OVERRIDEVARIABLE_FORM',
  ShowCreateVariableForm = 'SHOW_CREATEVARIABLE_FORM',
  ShowLeadForm = 'SHOW_LEAD_FORM',
  ShowMediaForm = 'SHOW_MEDIA_FORM',
  ShowAttachmentForm = 'SHOW_ATTACHMENT_FORM',
  ShowEndOfConversationForm = 'SHOW_END_Of_CONVERSATION_FORM',
  ShowDelayForm = 'SHOW_DELAY_FORM',
  ShowNotifyMeByEmail = 'SHOW_NOTIFY_ME_BY_EMAIL',
  ShowReceiveAttachment = 'SHOW_RECEIVE_ATTACHMENT',
  CloseForm = 'CLOSE_FORM',
  ShowSuperUserManagerServices = 'SHOW_SUPER_USER_MANAGER_SERVICES',
  ShowSpeechRecording = 'SHOW_SPEECH_RECORDING',
  ShowCheckIfUserExists = 'SHOW_CHECK_IF_USER_EXISTS',
  ShowUserCredential = 'SHOW_USER_CREDENTIAL',
  ShowGetUserInfo = 'SHOW_GET_USER_INFO',
  ShowRegisterUser = 'SHOW_REGISTER_USER',
  ShowPassToAi = 'SHOW_PASS_TO_AI',
  ShowSwitchToChatbot = 'SHOW_SWITCH_TO_CHATBOT',
  ShowAskToAI = 'SHOW_ASK_TO_AI',
  ShowSummarizeConversation = 'SHOW_SUMMARIZE_CONVERSATION',
  ShowJSCode = 'SHOW_JS_CODE',
}

// An interface for our state
export interface IMacBotState {
  parentId: string | null;
  data: any;
  isShowElseForm: boolean;
  isShowResponseForm: boolean;
  isShowUserInputForm: boolean;
  isShowVariableForm: boolean;
  isShowButtonForm: boolean;
  isShowGotoForm: boolean;
  isShowLinkForm: boolean;
  isShowHTTPRequestForm: boolean;
  isShowMakeWebHookForm?: boolean;
  isShowConditionForm: boolean;
  isShowOverrideVariableForm: boolean;
  isShowCreateVariableForm: boolean;
  isShowLeadForm: boolean;
  isShowMediaForm: boolean;
  isShowAttachmentForm: boolean;
  isShowEndOfConversationForm: boolean;
  isShowNotifyMeByEmailForm: boolean;
  isShowReceiveAttachmentForm: boolean;
  isShowDelayForm: boolean;
  isShowSuperUserManagerServices: boolean;
  isShowCheckIfUserExists: boolean;
  isShowUserCredential: boolean;
  isShowGetUserInfo: boolean;
  isShowRegisterUser: boolean;
  isShowPassToAi: boolean;
  isShowSwitchToChatbot: boolean;
  isShowSpeechRecording: boolean;
  isShowAskToAI: boolean;
  isShowSummarizeConversation: boolean;
  isShowJSCode: boolean;
}

// An interface for our actions
export interface IMacBotAction {
  type: MacBotActionKind;
  payload?: any;
}

export enum YoutubePosition {
  ScenarioHeader = 'SCENARIO_HEADER',
  Other = 'OTHER',
}
